module.exports = __webpack_public_path__ + "static/content-660ed9862c520c95313b66c6833c4eec.png";